/* eslint-disable import/prefer-default-export */
import type { RootState } from 'state/reducers';

import type { Notification } from './notificationsSlice';

export const selectNotifications = (state: RootState): Notification[] =>
  state.notifications.open;
